<!-- Modal for First Login -->
<app-overlay-message></app-overlay-message>

<div class="modal-overlay" *ngIf="firstLogin">
  <div class="modal-container">
    <div class="first-login-container">
      <h2>First Login Detected</h2>
      <hr />
      <p>Please reset or change your password to proceed.</p>

      <form [formGroup]="passwordForm" (ngSubmit)="onSubmitPasswordChange()">
        <div class="form-group-container">
          <div class="form-row">
            <div class="form-group">
              <label for="username">Username</label>
              <input type="text" id="username" formControlName="username" />
            </div>
            <div class="form-group">
              <label for="currentPassword">Current Password</label>
              <input
                type="password"
                id="currentPassword"
                placeholder="Current Password"
                formControlName="currentPassword"
              />
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label
                for="newPassword"
                [ngClass]="{
                  invalid:
                    passwordForm.errors?.mismatch &&
                    passwordForm.get('newPassword').invalid &&
                    passwordForm.get('newPassword').touched,
                  valid:
                    !passwordForm.errors?.mismatch &&
                    passwordForm.get('newPassword').valid &&
                    passwordForm.get('newPassword').touched
                }"
                >New Password</label
              >
              <input
                type="password"
                id="newPassword"
                placeholder="New Password"
                formControlName="newPassword"
                [ngClass]="{
                  invalid:
                    passwordForm.errors?.mismatch &&
                    passwordForm.get('newPassword').invalid &&
                    passwordForm.get('newPassword').touched,
                  valid:
                    !passwordForm.errors?.mismatch &&
                    passwordForm.get('newPassword').valid &&
                    passwordForm.get('newPassword').touched
                }"
              />
            </div>
            <div class="form-group">
              <label
                for="confirmPassword"
                [ngClass]="{
                  invalid:
                    passwordForm.errors?.mismatch &&
                    passwordForm.get('confirmPassword').invalid &&
                    passwordForm.get('confirmPassword').touched,
                  valid:
                    !passwordForm.errors?.mismatch &&
                    passwordForm.get('confirmPassword').valid &&
                    passwordForm.get('confirmPassword').touched
                }"
                >Confirm Password</label
              >
              <input
                type="password"
                id="confirmPassword"
                placeholder="Type New Password Again"
                formControlName="confirmPassword"
                [ngClass]="{
                  invalid:
                    passwordForm.errors?.mismatch &&
                    passwordForm.get('confirmPassword').invalid &&
                    passwordForm.get('confirmPassword').touched,
                  valid:
                    !passwordForm.errors?.mismatch &&
                    passwordForm.get('confirmPassword').valid &&
                    passwordForm.get('confirmPassword').touched
                }"
              />

              <div
                *ngIf="
                  (passwordForm.get('newPassword')?.touched ||
                    passwordForm.get('confirmPassword')?.touched) &&
                  passwordForm.get('newPassword')?.value.length > 0 &&
                  passwordForm.get('confirmPassword')?.value.length > 0
                "
                [ngStyle]="{
                  color: passwordForm.errors?.mismatch ? 'red' : 'green'
                }"
              >
                {{
                  passwordForm.errors?.mismatch
                    ? "Passwords do not match"
                    : "Passwords match"
                }}
              </div>
            </div>
          </div>
        </div>

        <div class="password-requirements">
          <p>Password Requirements:</p>
          <ul>
            <li
              [ngClass]="{
                valid:
                  passwordValidations.hasDigit &&
                  (passwordForm.get('newPassword').touched ||
                    passwordForm.get('confirmPassword').touched),
                invalid:
                  !passwordValidations.hasDigit &&
                  (passwordForm.get('newPassword').touched ||
                    passwordForm.get('confirmPassword').touched)
              }"
            >
              At least one digit
            </li>

            <li
              [ngClass]="{
                valid:
                  passwordValidations.hasLowercase &&
                  (passwordForm.get('newPassword').touched ||
                    passwordForm.get('confirmPassword').touched),
                invalid:
                  !passwordValidations.hasLowercase &&
                  (passwordForm.get('newPassword').touched ||
                    passwordForm.get('confirmPassword').touched)
              }"
            >
              At least one lowercase character
            </li>

            <li
              [ngClass]="{
                valid:
                  passwordValidations.hasUppercase &&
                  (passwordForm.get('newPassword').touched ||
                    passwordForm.get('confirmPassword').touched),
                invalid:
                  !passwordValidations.hasUppercase &&
                  (passwordForm.get('newPassword').touched ||
                    passwordForm.get('confirmPassword').touched)
              }"
            >
              At least one uppercase character
            </li>

            <li
              [ngClass]="{
                valid:
                  passwordValidations.hasMinLength &&
                  (passwordForm.get('newPassword').touched ||
                    passwordForm.get('confirmPassword').touched),
                invalid:
                  !passwordValidations.hasMinLength &&
                  (passwordForm.get('newPassword').touched ||
                    passwordForm.get('confirmPassword').touched)
              }"
            >
              At least 8 & max 15 characters in length
            </li>

            <li
              [ngClass]="{
                valid:
                  passwordValidations.hasOneSpecialCharacter &&
                  (passwordForm.get('newPassword').touched ||
                    passwordForm.get('confirmPassword').touched),
                invalid:
                  !passwordValidations.hasOneSpecialCharacter &&
                  (passwordForm.get('newPassword').touched ||
                    passwordForm.get('confirmPassword').touched)
              }"
            >
              At least one special character
            </li>
          </ul>
        </div>
        <hr />
        <div class="bottom-divider">
          <button
            type="submit"
            [disabled]="passwordForm.invalid"
            class="confirm-button"
          >
            Confirm
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- **************************LoginScreen -->
<div class="login-container" [ngClass]="{ 'blur-login-container': firstLogin }">
  <!-- Left Panel -->
  <div class="left-panel">
    <div class="left-header">
      <h1>WELCOME TO</h1>
      <h2>CONFIG <br /><span class="highlight">EXECUTION AGENT</span></h2>
      <p>
        The Configuration Hub enables automated instance creation, bringing
        efficiencies and shrinking release timelines.
      </p>
    </div>
    <form [formGroup]="loginForm" (ngSubmit)="login()" class="login-form">
      <label for="username">Username</label>
      <input
        type="email"
        id="username"
        formControlName="username"
        placeholder="Username"
        [ngClass]="{
          'ng-invalid':
            loginForm.get('username').invalid &&
            loginForm.get('username').touched,
          'ng-valid':
            loginForm.get('username').valid && loginForm.get('username').touched
        }"
      />
      <div
        *ngIf="
          loginForm.get('username').invalid && loginForm.get('username').touched
        "
      >
        <small
          class="error"
          *ngIf="loginForm.get('username').hasError('required')" style="color: red;"
          >Username is required</small
        >
        <small class="error" *ngIf="loginForm.get('username').hasError('email')" style="color: red;"
          >Please enter a valid Username</small
        >
      </div>

      <label for="password">Password</label>
      <input
        type="password"
        id="password"
        formControlName="password"
        placeholder="Password"
        [ngClass]="{
          'ng-invalid':
            loginForm.get('password').invalid &&
            loginForm.get('password').touched,
          'ng-valid':
            loginForm.get('password').valid && loginForm.get('password').touched
        }"
      />
      <div
        *ngIf="
          loginForm.get('password').invalid && loginForm.get('password').touched
        "
      >
        <small
          class="error"
          *ngIf="loginForm.get('password').hasError('required')" style="color: red;"
          >Password is required</small
        >
        <small
          class="error"
          *ngIf="loginForm.get('password').hasError('minlength')" style="color: red;"
          >Password must in between 8 to 15 characters</small
        >
      </div>

      <div class="login-btn">
        <button
          type="submit"
          class="login-button"
          [disabled]="loginForm.invalid"
        >
          Login
        </button>
      </div>
    </form>
  </div>

  <div class="right-panel"></div>
</div>
